import { useState, useEffect, useCallback } from 'react'
import { RequestService } from '../services/RequestService'

const useUserPreferencesFetcher = () => {
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState(null)

  const fetchData = useCallback(async () => {
    try {
      const { data } = await RequestService.getUserOnboardingPreferences()

      setData(data)
    } catch (e) {
      console.log('useUserPreferencesFetcher', e)
    }
    setLoading(false)
  }, [])

  useEffect(() => {
    fetchData()
  }, [])

  return { loading, data }
}

export default useUserPreferencesFetcher
